module.exports = __webpack_public_path__ + "img/icon-filter.c6f6c555.svg";